module.exports = __webpack_public_path__ + "static/media/cuaderno.a73cd9ea.svg";